var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilitySeatsAvailable = function SvgAccessibilitySeatsAvailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    d: "m25.643 28.489-2.002-11.634h.587a.42.42 0 0 0 0-.838h-.807a1.95 1.95 0 0 0-1.939-1.824H11.84a1.95 1.95 0 0 0-1.938 1.824H9.44a.964.964 0 0 1-.943-.744l-.293-1.248c1.027-.618 1.991-1.75 1.698-3.144l-1.73-7.22V3.65A2.634 2.634 0 0 0 5.28 1.753l-.095-.398a.421.421 0 0 0-.828.157.04.04 0 0 0 .01.031v.01l2.946 12.368v.01l.367 1.54a1.785 1.785 0 0 0 1.76 1.384h.283L7.722 28.49a.42.42 0 0 0 .324.492.42.42 0 0 0 .493-.325v-.02l.943-5.493h14.39l.943 5.492c.034.2.207.346.409.346a.2.2 0 0 0 .073-.01.41.41 0 0 0 .346-.482zM9.44 16.708h14.201"
  })));
};
export default SvgAccessibilitySeatsAvailable;